import type {z} from "zod";

import {UpdateMaterialCompositionBody} from "@project/sdk/engineering/zod";

export const updateMaterialCompositionFormSchema = UpdateMaterialCompositionBody;
export type UpdateMaterialCompositionFormPayload = z.output<
  typeof updateMaterialCompositionFormSchema
>;

export const draftUpdateMaterialCompositionFormSchema =
  updateMaterialCompositionFormSchema.partial();
export type DraftUpdateMaterialCompositionFormPayload = z.output<
  typeof draftUpdateMaterialCompositionFormSchema
>;
